import React from 'react';

const DocumentContext = React.createContext(null);

export const DocumentProvider = DocumentContext.Provider;

export default DocumentContext;
